
/* START_TEMPLATE */
define('hbs!app/views/templates/clubAccountList',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "        <a class=\"btn accountBtn\" data-parent=\"#accordion2\" href=\"#/membership/account/"
    + this.escapeExpression(((helper = (helper = helpers.AccountId || (depth0 != null ? depth0.AccountId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"AccountId","hash":{},"data":data}) : helper)))
    + "\">\r\n            "
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depths[1] != null ? depths[1].Localization : depths[1])) != null ? stack1.club : stack1)) != null ? stack1.accountNumber : stack1), depth0))
    + " "
    + this.escapeExpression(((helper = (helper = helpers.AccountId || (depth0 != null ? depth0.AccountId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"AccountId","hash":{},"data":data}) : helper)))
    + "\r\n        </a>\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, options, buffer = 
  "<h2>"
    + this.escapeExpression(this.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.Localization : depth0)) != null ? stack1.club : stack1)) != null ? stack1.selectAccount : stack1), depth0))
    + "</h2>\r\n<div class=\"viewAccOut\">\r\n    <div class=\"viewAcc\">\r\n";
  stack1 = ((helper = (helper = helpers.clubAccounts || (depth0 != null ? depth0.clubAccounts : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"clubAccounts","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.clubAccounts) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    </div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});
Handlebars.registerPartial('app/views/templates/clubAccountList', t);
return t;
});
/* END_TEMPLATE */
;
